import { GotoAction } from 'src/app/shared/models/action';
import { Injectable, isDevMode } from '@angular/core';
import { SharedController } from 'src/app/shared/shared-controller';
import { MainMenuService } from 'src/app/shared/services/mainmenu.service';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AuthService } from 'src/app/core/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AdminController extends SharedController {

    constructor(
        protected mms: MainMenuService,
        protected route: Router,
        protected auth: AuthService,
        protected gs: GeneralService
    ){
        super(mms, route, auth, gs);
        this.init();
    }
 
    init(){
        this.setMainMenu([
            new GotoAction('header','Dashboard', [this.gs.getBase(), 'home'], {main: true, icon: "tachometer-alt-fastest"}, this.route),
            new GotoAction('header','Pessoas', [this.gs.getBase(),'person'], {main: true, icon: "users"}, this.route),
            //isDevMode() && new GotoAction('header','Contas', [this.gs.getBase(),'accounts'], {main: true, icon: "user-circle"}, this.route),
            new GotoAction('header','Anúncios', [this.gs.getBase(),'ad'], {main: true, icon: "building"}, this.route),
            new GotoAction('header','Comunicação', [this.gs.getBase(),'communication'], {main: true, icon: "users"}, this.route),
            new GotoAction('header','Contatos', [this.gs.getBase(),'leads'], {main: true, icon: "envelope"}, this.route),
        ]);

        this.loadButtons();
        this.gs.setOptions({headerScrollTop : 50});
    }
}